// Lightweight FX rate client — proxies through our backend /api/fx
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api/estimator`;

const cache = new Map(); // base -> { fetchedAt, data }
const TTL_MS = 1000 * 60 * 60; // 1h in-memory

export async function fetchFxRates(base = "USD") {
  const key = base.toUpperCase();
  const now = Date.now();
  const cached = cache.get(key);
  if (cached && now - cached.fetchedAt < TTL_MS) return cached.data;

  const res = await axios.get(`${API}/fx`, { params: { base: key } });
  cache.set(key, { fetchedAt: now, data: res.data });
  return res.data;
}

export function convertAmount(amount, rates, fromCode, toCode) {
  if (!rates) return amount;
  if (fromCode === toCode) return amount;
  // We always fetch with base=toCode, so rates[fromCode] = units of `fromCode` per 1 `toCode`.
  // To convert `amount` (in fromCode) → toCode: divide by that rate.
  const r = rates[fromCode];
  if (typeof r !== "number" || r === 0) return amount;
  return amount / r;
}
